<template>
  <div class="admin-booking-manager-container">
    <el-card class="manager-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span class="header-title">陪玩预约管理</span>
      </div>
      
      <div class="search-container">
        <el-input
          placeholder="请输入选手名称"
          v-model="searchKeyword"
          class="search-input"
          @keyup.enter.native="fetchBookings"
          clearable
        >
          <el-button slot="append" icon="el-icon-search" @click="fetchBookings" type="primary"></el-button>
        </el-input>
      </div>
      
      <div class="booking-table">
        <el-table :data="bookings" style="width: 100%" stripe highlight-current-row>
          <el-table-column prop="id" label="预约ID" width="100" align="center"></el-table-column>
          <el-table-column prop="customerName" label="客户名称" width="120" align="center"></el-table-column>
          <el-table-column prop="playerName" label="选手名称" width="120" align="center"></el-table-column>
          <el-table-column prop="bookingDate" label="预约日期" width="150" align="center">
            <template slot-scope="scope">
              {{ formatDate(scope.row.bookingDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间" width="120" align="center"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" width="120" align="center"></el-table-column>
          <el-table-column prop="status" label="预约状态" width="120" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="getStatusType(scope.row.status)" 
                size="mini"
              >
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
        <el-table-column prop="note" label="备注" min-width="200">
          <template slot-scope="scope">
            <el-popover
              placement="top"
              :width="300"
              trigger="hover"
              :content="scope.row.note || '无备注'"
            >
              <span class="note-text">{{ scope.row.note || '无备注' }}</span>
            </el-popover>
          </template>
        </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180" align="center">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="180" align="center">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.updateTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button 
                v-if="scope.row.status === 0" 
                type="success" 
                size="mini" 
                @click="confirmBooking(scope.row.id)"
              >
                确认预约
              </el-button>
              <el-button 
                v-if="scope.row.status === 0" 
                type="danger" 
                size="mini" 
                @click="cancelBooking(scope.row.id)"
              >
                取消预约
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AdminBookingManager',
  data() {
    return {
      bookings: [],
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.fetchBookings()
  },
  methods: {
    fetchBookings() {
      const params = {};
      
      // 如果有搜索关键字，添加到参数中
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.trim();
        params.gameBuddyName = keyword;
      }
      
      this.$axios.get('/game-buddy/booking/list', { params }).then(res => {
        let data = res.data;
        this.bookings = data;
        this.total = data.length;
      }).catch(error => {
        this.$message.error('加载预约记录失败');
        console.error('Fetch bookings error:', error);
      });
    },
    getStatusType(status) {
      switch(status) {
        case 0: return 'warning'
        case 1: return 'success'
        case 2: return 'danger'
        default: return 'info'
      }
    },
    getStatusText(status) {
      switch(status) {
        case 0: return '待确认'
        case 1: return '已确认'
        case 2: return '已取消'
        default: return '未知状态'
      }
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return ''
      const date = new Date(dateTimeStr)
      if (isNaN(date.getTime())) return ''
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      // Handle ISO string with timezone
      if (dateStr.includes('T')) {
        return dateStr.split('T')[0]
      }
      // Handle simple date string
      return dateStr
    },
    confirmBooking(id) {
      this.$confirm('确定要确认这个预约吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        this.$axios.put(`/game-buddy/booking/confirm/${id}`)
          .then(res => {
            this.$message.success('确认预约成功')
            this.fetchBookings()
          })
          .catch(error => {
            this.$message.error('确认预约失败')
            console.error('Confirm booking error:', error)
          })
      }).catch(() => {
        this.$message.info('已取消确认')
      })
    },
    cancelBooking(id) {
      this.$confirm('确定要取消这个预约吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.put(`/game-buddy/booking/cancel/${id}`)
          .then(res => {
            this.$message.success('取消预约成功')
            this.fetchBookings()
          })
          .catch(error => {
            this.$message.error('取消预约失败')
            console.error('Cancel booking error:', error)
          })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchBookings()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.fetchBookings()
    }
  }
}
</script>

<style scoped>
.admin-booking-manager-container {
  padding: 20px 0;
}

.manager-card {
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.search-container {
  margin-bottom: 20px;
}

.search-input {
  width: 300px;
}

.booking-table {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: right;
}

.note-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 3em;
}

@media (max-width: 768px) {
  .search-input {
    width: 100%;
  }
}
</style>
